import { Observable, throwError } from "rxjs";
import { Escala, EscalaPeriodo } from "src/app/models/escala";
import { Estatistica, FiltroEstatistica } from "src/app/models/estatistica";
import { ScaleStore } from "../scale.store";
import { ItensEscalaPeriodoColaborador } from "src/app/models/itens_colaboradores";
import { Setor } from "src/app/models/setor";

export abstract class EscalaService {


  protected scaleStore: ScaleStore;
  constructor(scaleStore: ScaleStore) {
    this.scaleStore = scaleStore;
  }

  protected handleError(error: any) {
    return throwError(error);
  }

  protected log(message: string) {
    console.log('============= message response ============');
    console.log(message);
  }

  public abstract carregaEscalas(localId: number): Observable<Escala[]>;
  public abstract criaEscala(escala: Escala): Observable<Escala>;
  public abstract atualizarEscala(escalaId: number, changes: Partial<Escala>): Observable<Escala>;
  public abstract filtrarEscalaPorLocal(localId: number): Observable<Escala[]>;
  public abstract deletarEscala(escalaId: number): Observable<any>;
  public abstract getEscalas(localId: number): Observable<Escala[]>;

  public abstract removerColaboradorEscala(escalaId: number, colaboradorId: number): Observable<any>;

  public abstract carregaEstatisticas(): Observable<Estatistica[]>;
  public abstract criaEstatistica(estatistica: Estatistica): Observable<Estatistica>;
  public abstract filtrarEstatistica(estatisticaId: number): Observable<Estatistica>;
  public abstract filtrarEstatisticaPorEscala(escalaId: number, filtro: FiltroEstatistica): Observable<Estatistica>;
  public abstract aplicarEmMassaEscala(turnoId: number, items: { date: string, setorId: number, ponto?: boolean, id?: number }[]): Observable<any>;

  public abstract getEscalaPeriodo(id: number, periodo: string): Observable<EscalaPeriodo>;
  public abstract createPeriodo(id: number, periodo: string): Observable<EscalaPeriodo>;
  public abstract carregarItensColaboradores(ids: number[]): Observable<ItensEscalaPeriodoColaborador[]>;
  public abstract carregarEscalasAlocadoColaborador(idColaborador: number): Observable<Escala[]>

  public abstract removerColaboradorPeriodo(escalaPeriodoColaboradorId: number): Observable<any>;

  public abstract rolarEscala(escalaId: number, periodo: string): Observable<any>;

  public abstract duplicarEscala(escalaId: number): Observable<any>;
  public abstract gerarPdf(escalaId: number, periodo: string): Observable<any>;

  public abstract atualizarDetalhesEscala(escalaPeriodoId: number, publicado: boolean, ocultado: boolean, observacao: string): Observable<any>;


  public limparData(): void {
    this.scaleStore.clearData();
  }

}
